import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import format from '../../utils/format';
import { useAuth0 } from '@auth0/auth0-react';
import ComponentsNavigation from '../../sharedComponents/Navigation/Navigation';
import UserAuthButton from '../../sharedComponents/UserAuthButton/UserAuthButton';
import { assets } from '../../sharedComponents/assets';
import { UserLanguageSelector } from '../UserLanguageSelector/UserLanguageSelector';
import useUserLanguageConfig from '../../hooks/useUserLanguageConfig';
import { NavigationProps } from './Navigation.types';
import routeConfig from '../../router/RouteConfig';
import styles from './Navigation.module.scss';

const Navigation: React.FC<NavigationProps> = ({ isDisabled = false }) => {
  const LangGlobe = assets.svg.icons.LangGlobe;
  const location = useLocation();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const { logout, isAuthenticated } = useAuth0();
  const { supportedLanguages } = useUserLanguageConfig();

  const navItems: { element: JSX.Element; path: string }[] = routeConfig
    .filter((r) => r.displayInNavigation)
    .map((r) => {
      const name = r.name ?? t(r.nameKey);
      const Decoration = r.nameDecoration ?? (() => <></>);
      return {
        element: (
          <Link to={r.path}>
            <span className={styles.navItemTitle}>
              {format.toTitleCase(name)}
              <Decoration />
            </span>
          </Link>
        ),
        path: r.path,
      };
    });

  const logoLinkWrapper = (logo: JSX.Element): JSX.Element => {
    return <Link to="/trips">{logo}</Link>; //TODO: Update to `/` when enabling authed home page
  };

  return (
    <ComponentsNavigation
      items={navItems}
      currentPath={location.pathname}
      logoLinkWrapper={logoLinkWrapper}
      langSelector={
        <UserLanguageSelector
          icon={<LangGlobe />}
          options={supportedLanguages}
        />
      }
      authButton={
        <UserAuthButton
          signInOnClick={(): void => navigate('/login')}
          signOutOnClick={(): void => {
            void logout({
              logoutParams: {
                returnTo: window.location.origin + `?logout=true`,
              },
            });
          }}
          isSignedIn={isAuthenticated}
          signInLabel={t('action.signin')}
          signOutLabel={t('action.signout')}
          isDisabled={isDisabled}
        />
      }
    />
  );
};

export default Navigation;
